require('./SettingModalTabGeneral.scss');

const React = require('react'),
    ComponentUtils = require('utils/ComponentUtils'),
    ContentUtils = require('utils/ContentUtils'),
    UserServiceImpl = require('services/UserServiceImpl'),
    {t} = require('services/i18nextWrapper'),
    {PropTypes} = require('react'),
    Constants = require('constants/AppConstants'),
    {map, find} = require('lodash/collection'),
    Uploader = require('components/Commons/Uploader/Uploader'),
    TextField = require('components/Commons/TextField/TextField'),
    {findIndex} = require('lodash/array'),
    get = require('lodash/object').get,
    Security = require('services/Security').auth,
    {SelectField, Toggle} = require('material-ui'),
    SessionStore = require('stores/SessionStore');

const SettingModalTabGeneral = React.createClass({displayName: "SettingModalTabGeneral",

    /**
     * All currencies available
     */
    currencies: null,

    /**
     * All countries available
     */
    countries: null,

    propType: {
        model: PropTypes.object,
        onChangeSettings: PropTypes.func
    },

    getInitialState() {
        // all currencies and countries available
        this.currencies = require('currency-formatter').currencies;
        this.currencyDigits = require('../../../../assets/data/digits.json');
        this.countries = require('../../../../assets/data/countries.json');
        this.countries = ContentUtils.sortList(this.countries, 'name.common');
        const currencyCode = get(SessionStore.getCurrentCurrency(), 'code');
        const currencyDigitsCode = +get(SessionStore.getCurrentCurrencyDigits(), 'value');
        const applicantAddress = SessionStore.getApplicantAddress();
        const applicantPhone = SessionStore.getApplicantPhone();
        const email = SessionStore.getApplicantEmail();
        const applicantCityAndState = SessionStore.getApplicantCityAndState();
        const applicantTaxId = SessionStore.getApplicantTaxId();
        const applicantLogoSrc = Security.getCurrentApplicantLogoSrc();
        const applicantDisplayName = SessionStore.getApplicantDisplayName();

        const initialState = {
            preferredCurrencyName: SessionStore.getCurrentCurrency(),
            preferredCurrencyIndex: this._getCurrencyIndex(currencyCode),
            preferredDigitsIndex: this._getCurrencyDigitsIndex(currencyDigitsCode),
            preferredCountry: SessionStore.getCurrentCountry(),
            preferredCountryIndex: this._getCountryIndex(SessionStore.getCurrentCountry()),
            currentLanguageIndex: this._getCurrentLanguageIndex(),
            isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
            isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
            isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging(),
            isVisibleBrewingSection: SessionStore.isVisibleBrewingSection(),
            isVisibleFermentingSection: SessionStore.isVisibleFermentingSection(),
            isVisiblePackagingSection: SessionStore.isVisiblePackagingSection(),
            applicantAddress,
            applicantPhone,
            email,
            resultEmail: true,
            applicantCityAndState,
            applicantTaxId,
            applicantLogoSrc,
            applicantDisplayName
        };

        return initialState;
    },

    componentDidMount() {
        this.props.onChangeSettings(this.state);
    },

    onChangeCurrency(event, indexCurrency, selectedCurrency) {
        const preferredCurrency = find(this.currencies, (currency, index) => index === get(selectedCurrency, 'itemModel.payload'));
        const preferredCurrencyIndex = this._getCurrencyIndex(get(preferredCurrency, 'code'));

        this.setState({
            preferredCurrency,
            preferredCurrencyIndex
        }, () => {
            this.props.onChangeSettings({
                currencyCode: get(this.state.preferredCurrency, 'code'),
                countryCode: get(this.state.preferredCountry, 'cca2')
            });
        });
    },

    onChangeCurrencyDigits(event, indexCurrency, selectedCurrencyDigits) {
        
        const preferredDigits = get(selectedCurrencyDigits, 'text');
        const preferredDigitsIndex = this._getCurrencyDigitsIndex(+preferredDigits);

        this.setState({
            preferredDigits,
            preferredDigitsIndex
        }, () => {
            this.props.onChangeSettings({
                currencyDigits: +preferredDigits
            });
        });
    },

    onChangeCountry(evt, text, selectedItem) {
        const countryCurrencies = get(selectedItem, 'itemModel.currency');
        const isCurrencyAll = countryCurrencies.indexOf('ALL') > -1;

        let preferredCurrency;
        let preferredCurrencyCode;
        const preferredCountry = get(selectedItem, 'itemModel');

        if (isCurrencyAll) {
            // enter here means that this particular country we don't
            // know which specific currency use, so we choose default
            // currency defined
            preferredCurrencyCode = get(SessionStore.getCurrentCurrency(), 'code');
            preferredCurrency = find(this.currencies, currency => get(currency, 'code') === preferredCurrencyCode);
        } else {
            preferredCurrencyCode = get(countryCurrencies, '0'); // chose the first one;
            preferredCurrency = find(this.currencies, currency => get(currency, 'code') === preferredCurrencyCode);
        }

        this.setState({
            preferredCurrencyIndex: this._getCurrencyIndex(preferredCurrencyCode),
            preferredCountryIndex: this._getCountryIndex(selectedItem.itemModel),
            preferredCountry,
            preferredCurrency
        }, () => {
            this.props.onChangeSettings({
                currencyCode: get(this.state.preferredCurrency, 'code'),
                countryCode: get(this.state.preferredCountry, 'cca2'),
                applicantPhone: get(this.state, 'applicantPhone'),
                email: get(this.state, 'email'),
                applicantAddress: get(this.state, 'applicantAddress')
            });
        });
    },

    _getCountryIndex(countrySelected) {
        return findIndex(this.countries, country => get(country, 'cca2') === get(countrySelected, 'cca2')) + 1;
    },

    _getCurrentLanguageIndex() {
        const currentLocale = SessionStore.getCurrentLanguage();
        const targetIndex = Constants.LANGUAGE_ALLOWED.findIndex(value => {
            return value.value === currentLocale;
        });
        return targetIndex === -1 ? 1 : targetIndex + 1; // added extra one to prepare index of element
    },

    _getCurrencyIndex(currencyCodeSelected) {
        return findIndex(this.currencies, currency => get(currency, 'code') === currencyCodeSelected) + 1;
    },

    _getCurrencyDigitsIndex(currencyDigitsSelected) {
        return findIndex(this.currencyDigits, digits => +get(digits, 'value') === currencyDigitsSelected) + 1;
    },

    _getCountryMenuItems() {
        return ComponentUtils.toMenuItems(this.countries, 'name.common', 'location');
    },

    _getLanguageMenuItems() {
        const uniqueLenguage = map(Constants.LANGUAGE_ALLOWED, (text) => {
            return {payload: text, text: text.display};
        });
        return ComponentUtils.toMenuItems(uniqueLenguage, 'text', 'location');
    },

    onChangeLanguage(value) {
        this.setState({currentLanguageIndex: value.target.value}, () => {
            const locale = Constants.LANGUAGE_ALLOWED[get(this.state,'currentLanguageIndex') - 1];
            this.props.onChangeSettings({
                currentLanguageIndex: get(this.state,'currentLanguageIndex'),
                locale: locale.value
            });
        });
    },

    _getCurrencyMenuItems() {
        const currencies = map(this.currencies, (currency, payload) => {
            return {payload, text: `${get(currency, 'code')} - ${get(currency, 'symbol')}`};
        });
        return ComponentUtils.toMenuItems(currencies, 'text', 'currencies');
    },

    _getCurrencyDigitsMenuItems() {
        const currencyDigits = map(this.currencyDigits, (currencyDigit) => {
            return {text: `${currencyDigit.value}`};
        });
        return ComponentUtils.toMenuItems(currencyDigits, 'text', 'currencyDigits');
    },

    _onChangeAddress(evt) {
        const applicantAddress = get(evt, 'target.value');
        this.setState({
            applicantAddress
        }, () => {
            this.props.onChangeSettings({
                applicantAddress: get(this.state, 'applicantAddress')
            });
        });
    },

    _onChangeCityAndState(evt) {
        const applicantCityAndState = get(evt, 'target.value');
        this.setState({
            applicantCityAndState
        }, () => {
            this.props.onChangeSettings({
                applicantCityAndState: get(this.state, 'applicantCityAndState')
            });
        });
    },

    _onChangeTaxId(evt) {
        const applicantTaxId = get(evt, 'target.value');
        this.setState({
            applicantTaxId
        }, () => {
            this.props.onChangeSettings({
                applicantTaxId
            });
        });
    },

    _onChangePhone(evt) {
        const applicantPhone = get(evt, 'target.value');
        this.setState({
            applicantPhone
        }, () => {
            this.props.onChangeSettings({
                applicantPhone: get(this.state, 'applicantPhone')
            });
        });
    },

    _onChangeEmail(evt) {
        const email = get(evt, 'target.value');
        this.setState({
            email
        }, () => {
            this.props.onChangeSettings({
                email: get(this.state, 'email')
            });
        });
        UserServiceImpl.getEmailAlreadyUsed( () => {
            this.props.onChangeSettings({
                resultEmail: true
            });
        }, () => {
            this.props.onChangeSettings({
                resultEmail: false
            });
        } , Security.getToken(),Security.getCurrentApplicantId(),email);
    },

    _onChangeApplicantLogo(evt) {
        const applicantLogoSrc = evt.cdnUrl;
        this.setState({
            applicantLogoSrc
        }, () => {
            this.props.onChangeSettings({
                applicantLogoSrc
            });
        });
    },

    _onChangeApplicantName(evt) {
        const applicantDisplayName = get(evt, 'target.value');
        this.setState({
            applicantDisplayName
        }, () => {
            this.props.onChangeSettings({
                applicantDisplayName: get(this.state, 'applicantDisplayName')
            });
        });
    },

    render() {
        const languageMenuItems = this._getLanguageMenuItems();
        const currenciesMenuItems = this._getCurrencyMenuItems();
        const currencyDigitsMenuItems = this._getCurrencyDigitsMenuItems();
        const countriesMenuItems = this._getCountryMenuItems();

        return (
            React.createElement("div", {className: "bp-custom-modal__content bp-setting-modal-tab bp-setting-modal-tab-general", label: t('setting_modal_tab_gral_label_general')}, 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field logo-row"}, 
                    React.createElement("img", {className: "logo-img", src: this.state.applicantLogoSrc, alt: t('setting_modal_tab_gral_label_logo_of_applicant')}), 
                    React.createElement(Uploader, {imgSrc: this.state.applicantLogoSrc, onUploadComplete: this._onChangeApplicantLogo})
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeApplicantName, 
                        floatingLabelText: t('setting_modal_general_text_company_name'), 
                        value: this.state.applicantDisplayName}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeAddress, 
                        floatingLabelText: t('setting_modal_general_text_street_name_number'), 
                        value: this.state.applicantAddress}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeCityAndState, 
                        floatingLabelText: t('setting_modal_general_text_city_state_zip_code'), 
                        value: this.state.applicantCityAndState}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(SelectField, {
                        floatingLabelText: t('setting_modal_general_text_country'), 
                        onChange: this.onChangeCountry, 
                        menuItems: countriesMenuItems, 
                        disabled: SessionStore.isAdminUser() ? false : true, 
                        value: this.state.preferredCountryIndex}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangePhone, 
                        floatingLabelText: t('setting_modal_general_text_phone'), 
                        value: this.state.applicantPhone}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeEmail, 
                        onChange: this._onChangeEmail, 
                        floatingLabelText: t('setting_modal_general_text_email'), 
                        value: this.state.email, 
                        disabled: SessionStore.isAdminUser() ? false : true}
                    )
                ), 
                SessionStore.isAdminUser() && 
                    React.createElement("div", {className: "bp-setting-modal-tab-general__field alert alert-warning", style: {'max-width': '253px',
                        'margin-top': '10px',
                        'margin-bottom': '0px'}}, 
                        React.createElement("h6", {style: {'margin-top': '0px','margin-bottom': '0px'}}, t('setting_modal_general_email_message'))
                    ), 
                
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(SelectField, {
                        floatingLabelText: t('setting_modal_general_text_language'), 
                        menuItems: languageMenuItems, 
                        value: this.state.currentLanguageIndex, 
                        onChange: this.onChangeLanguage}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(SelectField, {
                        floatingLabelText: t('setting_modal_general_text_currency'), 
                        onChange: this.onChangeCurrency, 
                        menuItems: currenciesMenuItems, 
                        value: this.state.preferredCurrencyIndex, 
                        disabled: SessionStore.isAdminUser() ? false : true}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(SelectField, {
                        floatingLabelText: t('setting_modal_general_text_currency_digits'), 
                        onChange: this.onChangeCurrencyDigits, 
                        menuItems: currencyDigitsMenuItems, 
                        value: this.state.preferredDigitsIndex, 
                        disabled: SessionStore.isAdminUser() ? false : true}
                    ), 

                SessionStore.isAdminUser() && 
                    React.createElement("div", {className: "bp-setting-modal-tab-general__field alert alert-warning", style: {'max-width': '253px',
                        'margin-top': '10px',
                        'margin-bottom': '0px'}}, 
                        React.createElement("h6", {style: {'margin-top': '0px','margin-bottom': '0px'}}, t('setting_modal_general_text_currency_digits_help'))
                    )
                
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeTaxId, 
                        floatingLabelText: t('setting_modal_general_text_tax_id'), 
                        value: this.state.applicantTaxId}
                    )
                ), 
                
                
                React.createElement("div", {style: {margin: '20px 0'}}, 
                    React.createElement("h4", null, t('setting_modal_general_filter_section_title'), ":")
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                        label: t('brewing'), 
                        defaultToggled: this.state.isVisibleBrewingSection, 
                        onToggle: (_, value) => {
                            this.setState({
                                isVisibleBrewingSection: value
                            }, () => {
                                SessionStore.setIsVisibleBrewingSection(value);
                                this.props.onChangeSettings({
                                    isVisibleBrewingSection: value
                                });
                            });
                        }}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                        label: t('fermenting'), 
                        defaultToggled: this.state.isVisibleFermentingSection, 
                        onToggle: (_, value) => {
                            this.setState({
                                isVisibleFermentingSection: value
                            }, () => {
                                SessionStore.setIsVisibleFermentingSection(value);
                                this.props.onChangeSettings({
                                    isVisibleFermentingSection: value
                                });
                            });
                        }}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                        label: t('dashboard_modal_tab_packaging'), 
                        defaultToggled: this.state.isVisiblePackagingSection, 
                        onToggle: (_, value) => {
                            this.setState({
                                isVisiblePackagingSection: value
                            }, () => {
                                SessionStore.setIsVisiblePackagingSection(value);
                                this.props.onChangeSettings({
                                    isVisiblePackagingSection: value
                                });
                            });
                        }}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field alert alert-danger", style: {margin: '2px 0','max-width': '270px'}}, 
                    React.createElement("h6", {style: {'margin-top': '0px','margin-bottom': '0px'}}, t('setting_modal_general_filter_section_alert'))
                ), 
    
    
    
    
                React.createElement("div", {style: {margin: '20px 0'}}, 
                    React.createElement("h4", null, t('setting_modal_general_toggle_tile'), ":")
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                      label: t('brewing'), 
                      defaultToggled: this.state.isVisibleBeerStyleLabelBrewing, 
                      onToggle: (_, value) => {
                          this.setState({
                              isVisibleBeerStyleLabelBrewing: value
                          }, () => {
                              SessionStore.setIsVisibleBeerStyleLabelBrewing(value);
                              this.props.onChangeSettings({
                                  isVisibleBeerNameBrewingSection: value
                              });
                          });
                      }}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                      label: t('fermenting'), 
                      defaultToggled: this.state.isVisibleBeerStyleLabelFermenting, 
                      onToggle: (_, value) => {
                          this.setState({
                              isVisibleBeerStyleLabelFermenting: value
                          }, () => {
                              SessionStore.setIsVisibleBeerStyleLabelFermenting(value);
                              this.props.onChangeSettings({
                                  isVisibleBeerNameFermentingSection: value
                              });
                          });
                      }}
                    )
                ), 
                React.createElement("div", {className: "bp-setting-modal-tab-general__field toggle-option"}, 
                    React.createElement(Toggle, {
                      label: t('dashboard_modal_tab_packaging'), 
                      defaultToggled: this.state.isVisibleBeerStyleLabelPackaging, 
                      onToggle: (_, value) => {
                          this.setState({
                              isVisibleBeerStyleLabelPackaging: value
                          }, () => {
                              SessionStore.setIsVisibleBeerStyleLabelPackaging(value);
                              this.props.onChangeSettings({
                                  isVisibleBeerNamePackagingSection: value
                              });
                          });
                      }}
                    )
                )
                
            )
        );
    }

});

module.exports = SettingModalTabGeneral;



/** WEBPACK FOOTER **
 ** ./src/components/Header/SettingModal/SettingModalTabGeneral/SettingModalTabGeneral.js
 **/